import { render, staticRenderFns } from "./czl-comment-preview.vue?vue&type=template&id=466d5a63&scoped=true&"
import script from "./czl-comment-preview.vue?vue&type=script&lang=js&"
export * from "./czl-comment-preview.vue?vue&type=script&lang=js&"
import style0 from "./czl-comment-preview.vue?vue&type=style&index=0&id=466d5a63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466d5a63",
  null
  
)

export default component.exports